import { gql } from '@apollo/client';

export const SET_JOYRIDE = gql`
    mutation SetJoyride($name: String, $startDate: String, $endDate: String, $challenge: String, $target: Int) {
        setJoyride(name: $name, startDate: $startDate, endDate: $endDate, challenge: $challenge, target: $target) {
            id
            name
            startDate
            endDate
            challenge
            target
        }
    }
`;
